<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          :inline="false"
        />
      </div>
    </el-card>
    <!-- <el-card>
            <div slot="header" class="clearfix">
                <span style="font-weight:600;color:#000">充电用户费用信息</span>
            </div>
            <div class>
                <div style="display:flex">
                    <div style="width:150px;margin-left:50px;">充电用户优惠</div>
                    <div style="margin-left:26px;width:100px;">{{electricityType}}</div>
                    <div style="margin-left:50px;width:90px;">{{electricity}}</div>
                </div>
                <div style="margin-top: 20px;display:flex;">
                    <div style="margin-left:226px;width:100px;">{{serviceFeeType}}</div>
                    <div style="margin-left:50px;">{{serviceFee}}</div>
                </div>
            </div>
        </el-card>
        <el-card>
            <div slot="header" class="clearfix">
                <span style="font-weight:600;color:#000">运营商费用信息</span>
            </div>
            <div class>
                <div style="display:flex">
                    <div style="width:150px;margin-left:50px;">运营商结算优惠</div>
                    <div style="margin-left:26px;width:100px;">{{electricityType}}</div>
                    <div style="margin-left:50px;width:90px;">{{electricity}}</div>
                </div>
                <div style="margin-top:20px;display:flex;">
                    <div style="margin-left:226px;width:100px;">{{serviceFeeType}}</div>
                    <div style="margin-left:50px">{{serviceFee}}</div>
                </div>
            </div>
        </el-card>
        <el-card>
            <div slot="header" class="clearfix">
                <span style="font-weight:600;color:#000">开放电桩</span>
            </div>
            <el-form :model="form" ref="form" label-width="120px" style="width:100%;margin-top:20px;">
                <el-form-item label="选择电桩">
                  <STree v-model="form.target" :data="datatree" style="width:400px;margin-top:10px; margin-left:80px;" :isShowFilter="false"></STree>
                </el-form-item>
              </el-form>
        </el-card> -->
  </div>
</template>

<script>
export default {
  name: 'Liuliangfanganxiangqing',
  components: {},
  data() {
    return {
      id: '',
      // 方案信息
      rowdata: {},
      formfields: [
        {
          label: '方案名称',
          type: 'div',
          prop: 'name'
        },
        {
          label: '提供运营商',
          type: 'div',
          prop: 'operatorOrgName'
        },
        // {
        //     label: "电费原价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //     label: "服务费原价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //     label: "电费优惠价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //     label: "服务费优惠价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //     label: "电费活动价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //     label: "服务费活动价",
        //     type: "div",
        //     prop: "",
        // },
        // {
        //   label: '价格类型',
        //   type: 'div',
        //   prop: 'priceType'
        // },
        {
          label: '电费优惠',
          type: 'div',
          prop: 'elecDis'
        },
        {
          label: '服务费优惠',
          type: 'div',
          prop: 'serDis'
        },
        {
          label: '状态',
          type: 'div',
          prop: 'authStatusValue'
        },
        {
          label: '方案生效时间',
          type: 'div',
          prop: 'time'
        }
      ],
      connectorId: '',
      electricityType: '',
      electricity: '',
      serviceFeeType: '',
      serviceFee: '',
      form: {},
      datatree: []
    }
  },
  computed: {},
  mounted() {
    // 获取详情信息
    if (this.id) {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/entrance/getDataDetail',
        data: data,
        method: 'get',
        callback: (resp) => {
          console.log('resp', resp)
          this.rowdata = resp
          if (resp.electricityType == 'fixed') {
            resp.electricity = this.getFloat(resp.electricity)
            this.electricity = resp.electricity + '元'
          } else {
            this.electricity = resp.electricity + '%'
          }
          this.electricityType = resp.electricityTypeValue
          this.serviceFeeType = resp.serviceFeeTypeValue
          this.rowdata.elecDis = resp.electricityTypeValue + this.electricity

          if (resp.serviceFeeType == 'fixed') {
            resp.serviceFee = this.getFloat(resp.serviceFee)
            this.serviceFee = resp.serviceFee + '元'
          } else {
            this.serviceFee = resp.serviceFee + '%'
          }
          this.rowdata.serDis = resp.serviceFeeTypeValue + this.serviceFee

          if (resp.priceType === 0) {
            this.rowdata.priceType = '原价'
          } else {
            this.rowdata.priceType = '优惠价'
          }

          // 生效时间
          if (resp.endTime) {
            const time = resp.startTime + ' 至 ' + resp.endTime
            this.rowdata.time = time
          } else {
            const time = resp.startTime + '至永久'
            this.rowdata.time = time
          }
          this.rowdata.trafficDay = resp.trafficDay + '天'
          this.form.target = resp.target ? resp.target.split(',') : []
        }
      })
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/flowScheme/entranceDetail.vue